export const jobFunctions = [
  {
    name: "Sales",
    value: "Sales",
  },
  {
    name: "Recruitment",
    value: "Recruitment",
  },
];

export const messageTones = ["Casual", "Professional", "Explanatory"];

export const messageLength = ["Long", "Medium", "Short"];
